import { FC, PropsWithChildren } from 'react';

import { ChannelEventDistributor } from './channel-event-distributor';
import { ChannelProvider } from './channel-provider';

export const UserChannelEventProvider: FC<PropsWithChildren> = ({ children }) => {
	return (
		<ChannelProvider>
			<ChannelEventDistributor channel="UserDirectChannel">{children}</ChannelEventDistributor>
		</ChannelProvider>
	);
};
